/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          window.oRequestAnimationFrame      ||
          window.msRequestAnimationFrame     ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

(function () {

  "use strict";

  var myApp = {

  }

  myApp.init = function() {

    var ticking = false;
    var last_known_scroll_position;
    var vwH = window.innerHeight;
    var scrollHeight = document.documentElement.scrollHeight;


    ruralApp.Flexslider.initFlex('.flexslider',{animation: 'fade'});
    ruralApp.MagnificPopup.initMagnific('.gallery', {delegate: 'a', type: 'image', gallery: { enabled:true }});


    window.addEventListener('scroll', function(e) {
      last_known_scroll_position = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function() {
          checkScrollPos(last_known_scroll_position);
          ticking = false;
        });
      }
      ticking = true;

    });

    function checkScrollPos(scroll_pos) {
      var diffScroll = scrollHeight - vwH;
      if (scroll_pos > 43 && diffScroll > 200) {
        $('#header').removeClass('navbar-static-top');
        $('#header').addClass('navbar-fixed-top');
      } else {
        $('#header').removeClass('navbar-fixed-top');
        $('#header').addClass('navbar-static-top');
      }
    }
  }




  document.addEventListener('DOMContentLoaded', function() {
    myApp.init();
  }, false);


})();
